import { render, staticRenderFns } from "./CouponManagement.vue?vue&type=template&id=85c585d8&scoped=true&"
import script from "./CouponManagement.vue?vue&type=script&lang=js&"
export * from "./CouponManagement.vue?vue&type=script&lang=js&"
import style0 from "./CouponManagement.vue?vue&type=style&index=0&id=85c585d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c585d8",
  null
  
)

export default component.exports